import { useEffect, useState } from 'react';

const useLoadGoogleMapsScript = (libraries: string, apiKey?: string) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const scriptId = 'google-maps-script';

    if (document.getElementById(scriptId)) {
      setIsScriptLoaded(true);

      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}&callback=initMap`;
    script.async = true;

    document.head.appendChild(script);

    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).initMap = () => {
      setIsScriptLoaded(true);
    };

    script.onerror = () => {
      setError('Failed to load the Google Maps script');
    };

    return () => {
      document.head.removeChild(script);

      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      delete (window as any).initMap;
    };
  }, [apiKey, libraries]);

  return { isScriptLoaded, error };
};

export default useLoadGoogleMapsScript;
